import { Reducer } from 'redux';
import {
  GET_CORE_CACHE_STATUS, GET_RATE_CACHE_STATUS, RatecacheStatusActionTypes, RateCacheStatusState
} from '../types/rateCacheStatus.types';

const initialState: RateCacheStatusState = {
  rateCacheStatus: null,
  coreCacheStatus: null
};

export const rateCacheStatusReducer: Reducer<RateCacheStatusState> = (
  state: RateCacheStatusState = initialState, action
) => {
  switch ((action as RatecacheStatusActionTypes).type) {
    case GET_RATE_CACHE_STATUS:
      return {
        ...state,
        rateCacheStatus: action.payload.rateCacheStatus,
      };
    case GET_CORE_CACHE_STATUS:
      return {
        ...state,
        coreCacheStatus: action.payload.coreCacheStatus,
      };
    default:
      return state;
  }
};
